import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UserManagementPage from './pages/UserManagementPage';
import OrganizationsPage from './pages/OrganizationsPage';
import BusinessCategoriesPage from './pages/BusinessCategoriesPage';
import BranchesPage from './pages/BranchesPage';
import CampaignsPage from './pages/CampaignsPage';
import JobsPage from './pages/JobsPage';
import OperationsPage from './pages/OperationsPage';
import UnitsPage from './pages/UnitsPage';
import ReviewsPage from './pages/ReviewsPage';
import BranchRequestsPage from './pages/BranchRequestsPage';
import BranchRequestDetailPage from './pages/BranchRequestDetailPage';
import CampaignDetailPage from './pages/CampaignDetailPage';
import JobDetailPage from './pages/JobDetailPage';
import OperationDetailPage from './pages/OperationDetailPage';
import CountriesPage from './pages/CountriesPage';
import CitiesPage from './pages/CitiesPage';
import OrganizationDetailPage from './pages/OrganizationDetailPage';
import BranchDetailPage from './pages/BranchDetailPage';
import UserDetailPage from './pages/UserDetailPage';

function App() {
  const { checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth().catch(console.error);
  }, [checkAuth]);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<DashboardPage />} />
                  <Route path="/users" element={<UserManagementPage />} />
                  <Route path="/users/:id" element={<UserDetailPage />} />
                  <Route path="/organizations" element={<OrganizationsPage />} />
                  <Route path="/organizations/:id" element={<OrganizationDetailPage />} />
                  <Route path="/branches" element={<BranchesPage />} />
                  <Route path="/branches/:id" element={<BranchDetailPage />} />
                  <Route path="/campaigns" element={<CampaignsPage />} />
                  <Route path="/campaigns/:id" element={<CampaignDetailPage />} />
                  <Route path="/jobs" element={<JobsPage />} />
                  <Route path="/jobs/:id" element={<JobDetailPage />} />
                  <Route path="/operations" element={<OperationsPage />} />
                  <Route path="/operations/:id" element={<OperationDetailPage />} />
                  <Route path="/business-categories" element={<BusinessCategoriesPage />} />
                  <Route path="/branch-requests" element={<BranchRequestsPage />} />
                  <Route path="/branch-requests/:id" element={<BranchRequestDetailPage />} />
                  <Route path="/units" element={<UnitsPage />} />
                  <Route path="/reviews" element={<ReviewsPage />} />
                  <Route path="/countries" element={<CountriesPage />} />
                  <Route path="/cities" element={<CitiesPage />} />
                  <Route
                    path="/unauthorized"
                    element={<div className="p-4">Unauthorized Access</div>}
                  />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
